import { app } from '@src/store/modules/app';
import { FundriseRouteConfig } from 'vue-router';
import { login } from '@store/modules/login';
import { validateRouteAndNavigate } from './login-state-guards';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const loginRoutes: Array<FundriseRouteConfig> = [
	{
		path: `/login-verify`,
		name: 'login-two-factor',
		meta: { minTokenScopeRequired: 'REQUIRES_ADDITIONAL_AUTH' },
		beforeEnter: async (to, from, next) => {
			if (app.isAuthenticated) {
				next({ name: 'account-overview' });
			} else if (app.tokenScope === 'REQUIRES_ADDITIONAL_AUTH') {
				try {
					await login.storeTwoFactorMetadata();
					next();
				} catch {
					next({ name: 'forbidden' });
				}
			} else {
				next({ name: 'forbidden' });
			}
		},
		component: () =>
			import(/* webpackChunkName: "login-two-factor-select" */ '@views/account/login/login-two-factor.vue'),
		redirect: { name: 'login-two-factor-select' },
		children: [
			{
				path: `select`,
				name: 'login-two-factor-select',
				meta: { minTokenScopeRequired: 'REQUIRES_ADDITIONAL_AUTH' },
				beforeEnter: async (to, from, next) => {
					login.resetTwoFactorSelections();
					await validateRouteAndNavigate(next, 'login-two-factor-select');
				},
				component: () =>
					import(
						/* webpackChunkName: "login-two-factor-select" */ '@src/views/account/login/login-two-factor-select.vue'
					)
			},
			{
				path: `confirm`,
				name: 'login-two-factor-confirm',
				meta: { minTokenScopeRequired: 'REQUIRES_ADDITIONAL_AUTH' },
				beforeEnter: async (to, from, next) => {
					await validateRouteAndNavigate(next, 'login-two-factor-confirm');
				},
				component: () =>
					import(
						/* webpackChunkName: "login-two-factor-confirm" */ '@src/views/account/login/login-two-factor-confirm.vue'
					)
			}
		]
	},
	{
		path: `/locked-out`,
		name: 'login-locked-out',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import(/* webpackChunkName: "login-locked-out" */ '@views/account/login/login-locked-out.vue')
	},
	{
		path: '/customer-service/substitute-user/:userId/make-the-switch',
		name: 'substitute-user',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			try {
				await app.authenticateFromCornice();
				next({ name: 'account-overview' });
			} catch {
				next({ name: 'forbidden' });
			}
		}
	}
];
export default loginRoutes;
